import React from 'react';
import PropTypes from 'prop-types';
import { Divider } from 'antd';
import { capitalize } from 'lodash';

// import { LinkContainer } from 'react-router-bootstrap';
// Local Deps
// import { editUserRoute } from '../../../../../config/navigation/routes';
import trashCan from '../../../../../images/trashcan.svg';
import edit from '../../../../../images/edit.svg';
import EmailReset from '../EmailReset';

import './Actions.scss';
import { UserForApproveUser } from '../../../../../graphql/users';
import { getOrgByID } from '../../../../../graphql/organizationDetails';
import { addToOrganizationMembers, getUserByEmail } from '../../../../Billsby/graphql';

export default class Actions extends React.PureComponent {
  static propTypes = {
    cellProps: PropTypes.any.isRequired,
    deleteUser: PropTypes.func.isRequired,
    requestUserResetPassword: PropTypes.func.isRequired,
    approveUser: PropTypes.func.isRequired,
    openEditModal: PropTypes.func.isRequired,
    // unblockUser: PropTypes.func.isRequired,
  };

  render() {
    const {
      cellProps,
      deleteUser,
      requestUserResetPassword,
      approveUser,
      openEditModal
      // unblockUser,
    } = this.props;

    const updateUser = async (original) => {
      const response = await UserForApproveUser(original.id);
      const companyInfo = await getOrgByID(response.user.organizationId);
      const userInfo = await getUserByEmail(companyInfo.organization.email);
      if (userInfo.getUserByEmailOrganization) {
        const billsbyCustomerId = userInfo.getUserByEmailOrganization.billsbyCustomerId || '';
        const subscriptionLevel = capitalize(userInfo.getUserByEmailOrganization.subscriptionLevel) || '';
        const email = response.user.email;
        const response1 = await addToOrganizationMembers({ billsbyCustomerId, subscriptionLevel, email })
        console.log("updateUser: ", response1);
      }
    }

    return (
      <div>
        {cellProps.original.iconStatus === 'Approved' && (
          <div className="test">
            {/* <LinkContainer
              to={`${editUserRoute.replace(':userId', cellProps.original.id)}`}
              isActive={() => false}
            >
              <img className="nf-loading__img" src={edit} alt="Edit User" />
            </LinkContainer> */}
            <button
              className="administrative-action"
              onClick={() => {
                openEditModal(cellProps.original.id);
              }}
            >
              <img
                className="nf-loading__img"
                src={edit}
                alt="Delete User"
              />
            </button>
            <button
              className="administrative-action"
              onClick={() =>
                deleteUser(cellProps.original.id, cellProps.original.name, cellProps.original.organizationId)
              }
            >
              <img
                className="nf-loading__img"
                src={trashCan}
                alt="Delete User"
              />
            </button>
            <EmailReset
              name={cellProps.original.name}
              id={cellProps.original.id}
              title="Email Password Reset"
              tooltip="Send Password Change Request email to user"
              passwordReset={requestUserResetPassword}
            />
          </div>
        )}
        {cellProps.original.iconStatus === 'Requested' && (
          <div className="action-container">
            <button
              className="administrative-action approve"
              onClick={() => { approveUser(cellProps.original); updateUser(cellProps.original) }}
            >
              Approve
            </button>
            <Divider type="vertical" />
            <button
              className="administrative-action delete"
              onClick={() =>
                deleteUser(cellProps.original.id, cellProps.original.name, cellProps.original.organizationId)
              }
            >
              Delete
            </button>
          </div>
        )}

        {/* TO DO -No on clicks on spans */}
        {cellProps.original.iconStatus === 'Blocked' && (
          <div>
            <button
              className="administrative-action approve"
              onClick={() => approveUser(cellProps.original)}
            >
              Unblock
            </button>
            <Divider type="vertical" />
            <button
              className="administrative-action delete"
              onClick={() =>
                deleteUser(cellProps.original.id, cellProps.original.name, cellProps.original.organizationId)
              }
            >
              Delete
            </button>
          </div>
        )}

        {/* TO DO -No on clicks on spans */}
        {!cellProps.original.iconStatus && (
          <div style={{ fontWeight: '600' }}>
            <span>
              <button
                className="administrative-action"
                style={{ color: '#1890ff', cursor: 'pointer' }}
                onClick={() => approveUser(cellProps.original)}
              >
                Invite
              </button>
              <Divider type="vertical" />
              <button
                className="administrative-action"
                style={{ color: '#ff2f18', cursor: 'pointer' }}
                onClick={() =>
                  deleteUser(cellProps.original.id, cellProps.original.name, cellProps.original.organizationId)
                }
              >
                Delete
              </button>
            </span>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/ViewUsersGrid/subComponents/actions/Actions.jsx